import { FC, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useDeal } from 'src/apis/capacity-management/use-deal';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useReferrer } from 'src/hooks/use-referrer2';

const DetailsPage = lazy(() => import('./details/page'));
const AddPage = lazy(() => import('./add/page'));
const EditPage = lazy(() => import('./edit/page'));

export const DealAllocationToBalancingGroups: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();
  const deal = useDeal({ capacityManagementRoot });
  const referrer = useReferrer({
    label: 'My Transactions',
    location: '/reporting/my-transactions',
  });

  // avoid pop in of page titles in case of 401s
  if (!capacityManagementRoot.response) return <PageSpinner />;

  return (
    <Switch>
      <Route
        exact
        path="/reporting/my-transactions/deals/:dealId/allocation-to-balancing-groups/:direction(exit|entry)/:balancingGroupAllocationId/edit"
      >
        <EditPage
          deal={deal}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/deals/:dealId/allocation-to-balancing-groups/:direction(exit|entry)/add"
      >
        <AddPage
          deal={deal}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/deals/:dealId/allocation-to-balancing-groups/:direction(exit|entry)"
      >
        <DetailsPage
          deal={deal}
          capacityManagementRootResponse={capacityManagementRoot.response.data}
        />
      </Route>

      <Route
        path="/reporting/my-transactions/deals/:dealId/allocation-to-balancing-groups"
        exact
      >
        {!deal.response ? (
          <PageSpinner />
        ) : deal.response.data.exit?._links.balancingGroupAllocations ? (
          <Redirect
            to={referrer.attachTo({
              pathname: `/reporting/my-transactions/deals/${deal.response.data.dealId}/allocation-to-balancing-groups/exit`,
            })}
          />
        ) : (
          <Redirect
            to={referrer.attachTo({
              pathname: `/reporting/my-transactions/deals/${deal.response.data.dealId}/allocation-to-balancing-groups/entry`,
            })}
          />
        )}
      </Route>

      <ThrowNotFound />
    </Switch>
  );
};
